import axios from '../helpers/axios';
import { logError } from '../services';
import { IDropdownResponse, IResponse } from '../models';
import {
  ICreateNewPossessionPayload,
  IModelHomeFurniture,
  IModelHomeFurnitureDetails,
  IModelHomePayload,
  ITool
} from '../models/possessions';

export const getTools = async (filters?: {
  description?: string;
  category: string;
  phase: string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number | string;
}): Promise<IResponse<ITool[]>> => {
  try {
    const { data } = await axios.get(`/api/possessions/tools/list`, { params: filters });
    return data;
  } catch (error) {
    logError(error, 'getTools failed');
    return Promise.reject(error);
  }
};

export const getToolPhaseOptions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/possessions/tool-phases`);
    return data;
  } catch (error) {
    logError(error, 'getToolPhaseOptions failed');
    return Promise.reject(error);
  }
};

export const getToolCategoryOptions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/possessions/tool-categories`);
    return data;
  } catch (error) {
    logError(error, 'getToolCategoryOptions failed');
    return Promise.reject(error);
  }
};

export const getModelHomePossessionDetail = async (
  possessionId: string
): Promise<IModelHomeFurnitureDetails> => {
  try {
    const { data } = await axios.get(`/api/possessions/modelhomefurniture/${possessionId}`);
    return data;
  } catch (error) {
    logError(error, 'getModelHomePossessionDetail failed');
    return Promise.reject(error);
  }
};

export const updateModelHomePossessionDetail = async (
  possessionId: string,
  payload: IModelHomePayload
): Promise<any> => {
  try {
    const { data } = await axios.put(
      `/api/possessions/modelhomefurniture/${possessionId}`,
      payload
    );
    return data;
  } catch (error) {
    logError(error, 'updateModelHomePossessionDetail failed');
    return Promise.reject(error);
  }
};

export const getModelHomePossessionFurnitureTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/possessions/modelhomefurniture-types`);
    return data;
  } catch (error) {
    logError(error, 'getModelHomePossessionFurnitureTypes failed');
    return Promise.reject(error);
  }
};

export const updatePossessionImage = async (
  possessionId: string | number,
  imagePost: FormData
): Promise<string[]> => {
  try {
    const { data } = await axios.put(`/api/possessions/image/${possessionId}`, imagePost);
    return data;
  } catch (error: any) {
    logError(error, 'updatePossessionImage failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getModelHomeFurniture = async (filters?: {
  description?: string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number | string;
}): Promise<IResponse<IModelHomeFurniture[]>> => {
  try {
    const { data } = await axios.get(`/api/possessions/modelhomefurniture/list`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getModelHomeFurniture failed');
    return Promise.reject(error);
  }
};

export const createPossession = async (payload: ICreateNewPossessionPayload): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/possessions`, payload);
    return data;
  } catch (error) {
    logError(error, 'createPossession failed');
    return Promise.reject(error);
  }
};
